<template lang="html">
    <div class="right-panel can-scroll" v-loader-overlay="$props.loading">
        <div class="entity-card">
            <div class="entity-card-head">
                <div class="entity-head-left">
                    <slot name="header-left"></slot>
                </div>
                <div class="entity-head-center">
                    <slot name="header-center"></slot>
                </div>
                <div class="entity-head-right">
                    <slot name="header-right"></slot>
                </div>
            </div>
            <div class="entity-card-body">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'entity-page',
        props: {
            loading: {
                type: Boolean,
                deafult: false
            }
        }
    }
</script>
<style lang="sass">
    .entity-card
        display: flex
        flex-direction: column
        align-items: flex-start
        justify-content: flex-start
        height: 100%
        width: 100%
        .entity-card-head
            display: flex
            align-items: center
            justify-content: space-between
            flex-wrap: nowrap
            position: absolute
            top: 0
            left: 0
            right: 0
            background: #fff
            z-index: 15
            width: 100%
            flex-shrink: 0
            box-sizing: border-box
            margin: 0px !important
            height: 40px
            border-bottom: 1px solid #e0e0e0
            box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.1)
            .entity-head-left
                flex: initial
                flex-shrink: 0
                padding: 0 8px
            .entity-head-center
                flex: initial
                font-size: 14px
                line-height: 14px
                white-space: nowrap
                overflow: hidden
                text-overflow: ellipsis
                padding: 0 8px
            .entity-head-right
                display: flex
                align-items: center
                justify-content: space-between
                flex-wrap: nowrap
                flex-shrink: 0
                flex: initial
                padding: 0 8px
                margin: auto 0 auto auto
        .entity-card-body
            padding: 40px 0
            flex-grow: 1
            width: 100%
        .entity-card-footer
            display: flex
            align-items: center
            justify-content: space-between
            flex-wrap: nowrap
            position: absolute
            bottom: 0
            left: 0
            right: 0
            background: #fff
            z-index: 15
            flex-shrink: 0
            width: 100%
            box-sizing: border-box
            margin: 0px !important
            height: 40px
            border-top: 1px solid #e0e0e0
            box-shadow: 0px -3px 5px 0px rgba(0, 0, 0, 0.1)
            .print-btn
                display: flex
                align-items: center
                justify-content: flex-start
                position: relative
                height: 34px
                padding: 0 8px
                margin: 0 10px
                border: 1px solid rgba(0, 0, 0, 0.42)
                border-radius: 3px
                cursor: pointer
                text-align: center
                font-size: 12px
                line-height: 12px
</style>


// WEBPACK FOOTER //
// EntityPage.vue?14131af3